import './DynamicText.scss';
import { TextBase } from '@components/Component/TextBase/TextBase.js';
import { takeUntil } from 'rxjs';
/**
 * `Hint` component is for adding text to a form without any input or anything. Often placed below a grid or set of inputs to provide some context or instruction.
 */
export class DynamicText extends TextBase {
    get columnName() { return this._columnName; }
    set columnName(value) {
        if (this._columnName !== value) {
            // this._columnName = value;
            this._propertySet('columnName', value);
            if (this.record) {
                // reset our record subscription for the new column name.
                this.linkRecord(this.record);
            }
        }
    }
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'DynamicText';
        this._columnName = id;
        this.textElementType = 'span';
    }
    formDesignerPropertiesGet(properties) {
        properties = super.formDesignerPropertiesGet(properties);
        properties.columnName = ({
            id: 'columnName',
            value: this._columnName,
            componentType: 'Input',
            componentProperties: {},
            captionKey: 'formbuilder_dynamictext_columnname',
            propertyGroup: '',
            saveFlag: false
        });
        return properties;
    }
    /**
     * Link the field to a record by its columnName. This syncs the field `caption` with the record.data[columnName].
     * @param record - The record to link to
     */
    linkRecord(record) {
        super.linkRecord(record);
        this.recordSubscription = record.get$(this._columnName, { ignoreSource: [this.id] })
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
            if (this.formDesignerMode && !value) {
                value = 'Placeholder Text';
            }
            this.caption = value;
        });
    }
}
DynamicText.VERSION = '$Revision: 112048 $';
